<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M10.0082 0C4.48104 0 0 4.47368 0 9.99178C0 14.227 2.63591 17.8454 6.35913 19.301C6.26852 18.5115 6.19438 17.2944 6.39208 16.4309C6.5733 15.6497 7.56176 11.4638 7.56176 11.4638C7.56176 11.4638 7.26522 10.8635 7.26522 9.98355C7.26522 8.59375 8.07247 7.55757 9.07741 7.55757C9.93408 7.55757 10.3459 8.19901 10.3459 8.96382C10.3459 9.81908 9.80228 11.102 9.51398 12.2944C9.2751 13.2895 10.0165 14.1036 10.9967 14.1036C12.7759 14.1036 14.1433 12.2286 14.1433 9.53125C14.1433 7.13816 12.4217 5.46875 9.95879 5.46875C7.10872 5.46875 5.43656 7.59868 5.43656 9.80263C5.43656 10.6579 5.76605 11.5789 6.17791 12.0806C6.26028 12.1793 6.26852 12.2697 6.24381 12.3684C6.16967 12.6809 5.99669 13.3635 5.96374 13.5033C5.92256 13.6842 5.81547 13.7253 5.62602 13.6349C4.37396 13.051 3.59143 11.2336 3.59143 9.76151C3.59143 6.61184 5.88137 3.71711 10.2059 3.71711C13.6738 3.71711 16.3756 6.18421 16.3756 9.49013C16.3756 12.9359 14.201 15.7072 11.1861 15.7072C10.173 15.7072 9.21744 15.1809 8.89619 14.5559C8.89619 14.5559 8.39372 16.4638 8.27016 16.9326C8.04776 17.8043 7.4382 18.8898 7.02634 19.5559C7.96539 19.8438 8.95385 20 9.99174 20C15.5189 20 20 15.5263 20 10.0082C20.0164 4.47368 15.5354 0 10.0082 0Z" 
    fill="#E60023" />
  </svg>
</template>

<script>
export default {
  name: 'PinterestPlatformIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped></style>